<template>
    <div   class="opacity-[0.33] bg-[#6095e4ad] z-[850] modal show  fixed top-0 left-0 w-full h-full outline-none overflow-x-hidden overflow-y-auto"    tabindex="-1" aria-labelledby="exampleModalCenterTitle" aria-modal="true" role="dialog">
                <div class="modal-dialog modal-dialog-centered relative w-auto pointer-events-none">
                    <div class="modal-content border-none relative 
                    flex flex-col w-full pointer-events-auto
                     outline-none text-current">
                        <div class="flex  justify-center items-center">
                            <div class="w-12 h-12 spinner-border animate-spin inline-block   border-4 rounded-full" role="status">
                                <span class="visually-hidden">Loading...</span>
                            </div>
                            
                        </div>
                    </div>
                </div>
            </div>
</template>

<script>
export default {
    // v-if="show" @click="closeInside" 
//     data: () => ({
//  show:true,
// }),
name:'Loader',
methods:{
         closeModal(){
               this.$emit('close',false)
         },
       
},
    mounted() {
     setTimeout(() => {
        this.closeModal();
    }, 20000)
 },

}
</script>

<style>
.colorModal{
    background: #6095e4ad;
}
</style>